/** Maps to GraphQL `CompetitionType`. */
export enum CompetitionScoringType {
  VOTE_OUTCOME = 'VOTE_OUTCOME',
  CORRECT_SCORE = 'CORRECT_SCORE',
  /** Tipster performance cup — ranked by settled tips in the active window. */
  TIPSTER_PERFORMANCE = 'TIPSTER_PERFORMANCE',
}

export enum CompetitionSportScope {
  ALL = 'ALL',
  SELECTED = 'SELECTED',
}

/** User-facing competition product (Figma + menu). */
export enum CompetitionAudience {
  /** Events and voting — default admin create flow. */
  USER = 'USER',
  /** Performance ranking — BetBrothers / feature-flagged. */
  TIPSTER = 'TIPSTER',
}

export const UNLIMITED_MAX_PARTICIPANTS = 999_999

export const COMPETITION_COVER_ASPECT = 16 / 9
